import { ListBoxContainer, ReactIcons, Switch } from "@kalyzee/kalyzee-ui"
import { MeetingContainerAPI } from "@kalyzee/kast-web-sdk";
import MeetingSessionMediaPlayer from "../player/MeetingSessionMediaPlayer";

import workBoxStyles from "./WorkBox.module.css";
import { useMemo } from "react";
import { useStudentContext } from "../../pages/master/student/context";
import { useMeetingSelector } from "../../hooks/meeting";
import { Video } from "@kalyzee/kast-web-sdk/web-components";
import { useBoardMedia } from "../../hooks/board";
import { LocalOrRemoteMedia } from "../../hooks/ovenmedia";
import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import { MasterPlayerWorkBox } from "./MasterPlayerWorkBox";

import styles from "./BoardInputsWorbox.module.css";

export interface InputsWorkBoxProps {
  meetingAPI: MeetingContainerAPI;
}

export const BoardInputsWorkBox = ({
  meetingAPI,
}: InputsWorkBoxProps) => {
  const studentCtx = useStudentContext();

  const [meeting] = useMeetingSelector(meetingAPI, (state) => state.meeting);

  const inputs = useBoardMedia(meetingAPI);

  const inputItems = useMemo(() => {
    if (!studentCtx || !meeting || !inputs) return [];
    const meetingOptions = studentCtx.getMeetingOptions(meeting.id) ?? {};

    const onSelectInputItem = (sessionId: string) => {
      const selectedSessions = meetingOptions.disabledVideoSessionIds ?? [];
      const index = selectedSessions.indexOf(sessionId);
      if (index === -1) {
        studentCtx.updateMeetingOptions(meeting.id, {
          disabledVideoSessionIds: [...selectedSessions, sessionId],
        });
      } else {
        studentCtx.updateMeetingOptions(meeting.id, {
          disabledVideoSessionIds: selectedSessions.filter((s) => s !== sessionId),
        });
      }
    };

    const data = inputs.map((input) => {
      const mediaSessionId = input.mediaSession.id;
      const isSelected = !meetingOptions.disabledVideoSessionIds?.includes(mediaSessionId);
      return {
        input,
        selected: isSelected,
        onSelect: () => onSelectInputItem(mediaSessionId),
      };
    });

    return data;
  }, [meeting, studentCtx, inputs]);
  
  const renderLocalOrRemoteInput = (
    meeting: Meeting,
    input: LocalOrRemoteMedia,
    selected: boolean,
  ) => {
    return (
      input.type === "remote" ? (
        <MeetingSessionMediaPlayer
          meeting={meeting}
          sessionId={input.session.id}
          mediaSessionId={input.mediaSession.id}
          ovenMediaSession={input.videoSession}
          muted={true}
          style={{
            overflow: "hidden",
            opacity: selected ? 1 : 0.5,
            width: "100%",
            height: "100%",
          }}
          videoStyle={{
            objectFit: "cover",
          }}
        />
      ) : (
        <div style={{
          overflow: "hidden",
          position: "relative",
          opacity: selected ? 1 : 0.5,
          width: "100%",
          height: "100%",
        }}>
          <Video
            style={{ objectFit: "cover", width: "100%" }}
            src={input.stream}
            autoPlay
            muted
          />
          <div style={{
            position: "absolute",
            top: 5,
            left: 10,
            color: "white",
            fontSize: "0.75em",
            backgroundColor: "#00000088",
            padding: "2px 5px",
            borderRadius: 5,
            
          }}>
            local-stream
          </div>
        </div>
      )
    );
  }

  const renderItems = () => {
    if (!meeting) return [];
    return inputItems.map((inputItem) => {
      const input = inputItem.input;
      return (
        <MasterPlayerWorkBox
          meetingAPI={meetingAPI}
          session={input.session}
          mediaSession={input.mediaSession}
          extraHeaderContent={
            <Switch
              value={inputItem.selected}
              switchNativeProps={{ disabled: true }}
            />
          }
          className={styles.inputContainer}
          nativeProps={{
            onClick: inputItem.onSelect,
            style: {
              aspectRatio: "3 / 1",
            }
          }}
          overlayMode="normal"
        >
          {renderLocalOrRemoteInput(meeting, input, inputItem.selected)}
        </MasterPlayerWorkBox>
      );
    });
  }

  return (
    <ListBoxContainer
      style={{ width: "100%", height: "100%" }}
      topBarProps={{
        center: [
          <ReactIcons.PlayScreens style={{ width: 31 }} />,
          <span className={workBoxStyles.label}>Affichage</span>
        ],
      }}
      items={renderItems()}
    />
  );
}